import axios from "./index";

class PDFApi {
  static generateDocument = async (documentType, objectId, options = {}) => {
    try {
      const response = await axios.get(`/pdf/generate/${documentType}/${objectId}/`, {
        responseType: "blob",
        ...options,
      });
      return response;
    } catch (error) {
      console.error(`Error generando documento ${documentType}:`, error);
      throw error;
    }
  };
}

export default PDFApi;
